import { notNull } from "./notNull";

export function sumUndefinedNumbers(
  ...numbers: (number | undefined)[]
): number {
  if (numbers.some((num) => num === undefined)) {
    return 0;
  }
  return numbers.filter(notNull).reduce((sum, num) => sum + (num ?? 0), 0);
}
